import { api } from '@/lib/api'
import type { APIResponse } from '@/types/api'
import type { Project } from '@/types/project'

export interface CreateProjectData {
	companyID: string
	code: string
	name: string
}

export interface UpdateProjectData {
	id: string
	code: string
	companyID: string
	name?: string
}

/**
 * Servicio para gestionar proyectos
 */
export class ProjectsService {
	/**
	 * Obtiene todos los proyectos de una empresa
	 */
	static async getProjectsByCompany(companyID: string): Promise<Project[]> {
		const response = await api.get<APIResponse<Project[]>>(`/projects`, {
			params: { companyID },
		})
		const apiResponse = response.data

		if (!apiResponse.success || !apiResponse.data) {
			throw new Error(apiResponse.message || 'Error al obtener proyectos')
		}

		return apiResponse.data
	}

	/**
	 * Crea un nuevo proyecto
	 */
	static async createProject(data: CreateProjectData): Promise<Project> {
		const response = await api.post<APIResponse<Project>>(`/projects`, data)
		const apiResponse = response.data

		if (!apiResponse.success || !apiResponse.data) {
			throw new Error(apiResponse.message || 'Error al crear proyecto')
		}

		return apiResponse.data
	}

	/**
	 * Actualiza un proyecto
	 */
	static async updateProject(data: UpdateProjectData): Promise<Project> {
		const response = await api.put<APIResponse<Project>>(`/projects`, data)
		const apiResponse = response.data

		if (!apiResponse.success || !apiResponse.data) {
			throw new Error(apiResponse.message || 'Error al actualizar proyecto')
		}

		return apiResponse.data
	}

	/**
	 * Elimina un proyecto
	 */
	static async deleteProject(id: string): Promise<void> {
		const response = await api.delete<APIResponse<void>>(`/projects?id=${id}`)
		const apiResponse = response.data

		if (!apiResponse.success) {
			throw new Error(apiResponse.message || 'Error al eliminar proyecto')
		}
	}
}
